import { useEffect, useState } from "react";

/**
 * Restituisce una versione debounced del valore. Utile per:
 *  - `filters.q` che sta nelle `useEffect` deps di una pagina che carica
 *    dati da API: evita 1 chiamata per carattere.
 *  - `useMemo` che filtrano liste grandi (es. 500+ righe).
 *
 * Uso tipico:
 *   const [q, setQ] = useState("");
 *   const debouncedQ = useDebouncedValue(q, 350);
 *   useEffect(() => { fetch(...) }, [debouncedQ]);
 *
 * Nota: l'input rimane immediato (controlled da `q`), è la propagazione
 * ai listener che è ritardata.
 */
export function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
